const en_CA = {
  code: "en-CA",
  language: {
    code: "en",
    name: "English",
  },

  labels: {
    active: "Active",
    actions: "Actions",
    add: "Add",
    address: "Address",
    address_street: "Street Address",
    "address.streetAddress": "Street Address",
    address_other: "Other",
    address_city: "City",
    "address.city": "City",
    address_province: "Province",
    "address.province": "Province",
    address_postal: "Postal Code",
    apply: "Apply",
    applyListings: "Apply Listings to Matrix",
    artifactBuilder: "Artifact Builder",
    area: "Area",
    availability: "Availability",
    banner: "Banner",
    banners: "Banners",
    callDashboard: "Call Dashboard",
    clientDashboard: "Client Dashboard",
    repDashboard: "Rep Dashboard",
    callDuration: "Duration",
    callDurationOutliers: "Call Duration Outliers",
    callInfo: "Call Information",
    callVariance: "Variance",
    call: "Call",
    calls: "Calls",
    cancel: "Cancel",
    category: "Category",
    cellPhone: "Cell Phone",
    change: "Change",
    city: "City",
    client: "Client",
    clientCode: "Client Code",
    clientFields: "Client Fields",
    clients: "Clients",
    clientPortals: "Client Portals",
    clientPortalCatalog: "Client Portal Catalog",
    clientPortalModules: "Client Portal Modules",
    code: "Code/UPC",
    communication: "Communication",
    confirmDelete: "Confirm",
    controlledBy: "Controlled By",
    controls: "Controls",
    courierAddress: "Courier Address",
    customFields: "Custom Fields",
    duration: "Duration",
    email: "Email Address",
    employeeNumber: "Employee Number",
    expenses: "Expenses",
    endsOn: "Ends On",
    exportScheduleTemplate: "Export Schedule Template",
    family: "Product Family",
    filter: "Filter",
    filters: "Filters",
    finishedAt: "Finished At",
    firstCall: "First Call",
    from: "From",
    highDef: "High Def",
    home: "Home",
    homeMileage: "Home Mileage",
    hourlyRate: "Rate",
    import: "Import",
    inventory: "Inventory",
    isActive: "Is Active",
    isMandatory: "Mandatory",
    allowExpenses: "Allow Expenses",
    isRequired: "Required",
    language: "Language",
    lastCall: "Last Call",
    legalName: "Legal Name",
    location: "Location",
    locationNumber: "#",
    portalModules: "Portal Modules",
    locations: "Locations",
    latitude: "Latitude",
    longitude: "Longitude",
    mapSelected: "Map Selected",
    mapLocation: "Map Location",
    mappingLocations: "Mapping {count} of {total} locations",
    missingCoords: "Missing Coords",
    logic: "Logic",
    login: "Login",
    logout: "Logout",
    messages: "Messages",
    manager: "Manager",
    matrixItems: "Matrix Items",
    mileage: "Mileage",
    moveable: "moveable",
    mySchedule: "My Schedule",
    name: "Name",
    name_fr: "Name (fr)",
    newPage: "Page",
    newQuestion: "Question",
    newSection: "Section",
    onlyListedSkus: "Only listed Skus",
    options: "Options",
    openMap: "Open map",
    otherAddress: "Other Address",
    packSize: "Pack Size",
    baseUom: "Base UOM",
    unitsPerPack: "Units Per Pack",
    unitsPerCase: "Units Per Case",
    pagesControlled: "Pages Controlled",
    password: "Password",
    pendingExpenseApprovals: "Expenses Pending",
    pendingCallDurationOutliers: "Duration Outliers",
    payPeriod_processing: "Pay Period Processing",
    payroll: "Payroll",
    payReceipt: "Pay Receipt",
    adpConfiguration: "ADP Configuration",
    prev: "Prev",
    postal: "Postal",
    previousAnswer: "Previous Answer",
    price: "Price",
    product: "Product",
    products: "Products",
    productOnShelf: "Product on Shelf",
    project: "Project",
    projectType: "Project Type",
    projectCode: "Project Code",
    privacyPolicy: "Privacy Policy",
    province: "Province",
    provinces: "Provinces",
    questionsControlled: "Questions Controlled",
    qa: "QA Review",
    region: "Region",
    reason: "Reason",
    repActions: "Rep Actions",
    rep: "Rep",
    reps: "Reps",
    repsCanChange: "Change",
    repsCanAdd: "Add",
    reassignRepOptional: "Reassign Rep (Optional)",
    rescheduled: "rescheduled",
    reassigned: "reassigned",
    and: "and",
    resolution: "Resolution",
    retailer: "Retailer",
    retailers: "Retailers",
    role: "Role",
    supervisor: "Supervisor",
    teamLead: "Team Lead",
    assignedProvinces: "Assigned Provinces",
    roiDistribution: "ROI Distribution",
    roiOOS: "ROI Out-of-Stock",
    scheduledDuration: "Scheduled Duration",
    scheduleTemplate: "Schedule Template",
    scheduledLocations: "Scheduled Locations",
    scheduledCalls: "Scheduled Calls",
    scheduledLocationsEmpty: "No scheduled locations for the current filters",
    noLocationsWithCoordinates: "No locations with coordinates available",
    searchLocationOrProject: "Search location or project",
    selectAll: "Select All",
    setToSpecificDate: "Set to Specific Date",
    relativeDays: "Relative (Days)",
    relativeDaysPlaceholder: "e.g., 5 or -3",
    rescheduleType: "Reschedule Type",
    rescheduleTo: "Reschedule to:",
    adjustByDays: "Adjust by (days):",
    adjustDaysHelperText: "Positive for future dates, negative for past dates",
    startDate: "Start",
    endDate: "End",
    today: "Today",
    next: "Next",
    closeMap: "Close map",
    mapFor: "Map for",
    noRepsAvailable: "No reps available",
    applyChanges: "Apply Changes",
    clear: "Clear",
    failedCalls: "Failed Calls:",
    partialSuccess: "Partial Success",
    success: "Success",
    error: "Error",
    of: "of",
    search: "Search",
    sectionsControlled: "Sections Controlled",
    sectionText: "Section Text",
    select_file: "Select File",
    select_logo: "Select Logo",
    selectedLocations: "Selected Locations",
    selectSkusForMatrix: "Select the SKUs you want in this matrix",
    shelfTag: "Shelf Tag",
    shelfTagAdded: "Did you add a shelf tag?",
    shelfTagOnEntry: "Was there a shelf tag on ENTRY?",
    showClientFields: "Show Client Fields",
    showFields: "Show Fields",
    skuMatrix: "SKU Matrix",
    startedAt: "Started At",
    startsOn: "Starts On",
    streetAddress: "Street Address",
    surveyDashboard: "Survey Dashboard",
    syncSupport: "Sync Support",
    supervisorCalendar: "Supervisor Calendar",
    surveyImages: "Survey Images",
    surveyDesigner: "Survey Designer",
    surveyPages: "Survey Pages",
    surveyType: "Survey Type",
    syncDashboard: "Sync Dashboard",
    syncReport: "Sync Report",
    synchronization: "Synchronization",
    syncSupport: "Sync Support",
    syndication: "Syndication",
    syndicatedTerritory: "Syndicated Territory",
    syndicatedTerritories: "Syndicated Territories",
    territory: "Territory",
    to: "To",
    totalRecords: "Total Records",
    type: "Type",
    upc: "UPC",
    update: "Update",
    unknown: "Unknown",
    username: "Username",
    user: "User",
    users: "Users",
    value: "Value",
    variability: "Variability",
    visibility: "Visibility",
  },

  messages: {
    cancelChanges: "Cancel Changes?",
    changesWillBeLost: "Changes have been made. Do you wish to cancel them?",
    selectAtLeastOneCall: "Please select at least one call",
    selectRescheduleOrReassign:
      "Please select a reschedule date/days or a new rep to reassign",
    unableToLoadCallDetails: "Unable to load call details",
    errorProcessingCalls: "Error processing calls: {error}",
    allCallsActionSuccess: "All {count} call(s) {actions} successfully",
    partialCallsActionSuccess:
      "{successCount} of {totalCount} call(s) {actions} successfully. {errorCount} failed due to blackout restrictions or other issues.",
    allCallsActionFailed: "All {totalCount} call(s) failed to {actions}.",
    unexpectedResult: "Unexpected result from server",
    confirmSurveyDeleteWithAnswers: `This survey has {answerCount} answers.\nIf you continue these answers will be deleted also.\n\nARE YOU SURE?`,
    confirmSurveyDeleteWithoutAnswers: `This action cannot be undone.\n\nARE YOU SURE?`,
    basedOnPage: "based on page...",
    basedOnSection: "based on section...",
    basedOnSurvey: "based on survey...",
    deleted: "Deleted",
    downloadDialog:
      "Please select what you wish to do with your selected items",
    endOfSurvey: "End of Survey",
    fieldErrors: "Field Errors. Please review and fix.",
    fileWillBeEmailed: "your file will be emailed to you shortly!",
    invalidCredentials: "Invalid Credentials",
    locationsMoved: "Locations have been moved to new territory",
    missing: "Missing data",
    missingAnswers:
      "Unable to Save! Please review your call report. You are missing mandatory answers.",
    geocodeMissing:
      "Select locations missing coordinates. Leave none selected to update all missing locations.",
    noAvailableQuestions: "No control questions available...",
    noListingsInLocation: "There are no listings for this location",
    noMatrixItems: "No Matrix Items...",
    noProducts: "No Products...",
    noProjects: "No Projects...",
    noQuestions: "No questions added",
    noRecords: "0 records found",
    noSections: "No sections added",
    noSkus: "No skus added...",
    notAllowedToMove:
      "Cannot move. Logic is attached. Please remove before moving.",
    notSet: "not set...",
    pageSequenceSaved: "Page Sequence Saved!",
    passedValidation:
      "Call Report eligible to save! All mandatory questions answered.",
    questionSequenceSaved: "Question Sequence Saved!",
    saved: "Saved!",
    sectionSequenceSaved: "Section Sequence Saved!",
    startOfSurvey: "Start of Survey",
    surveyNotStarted: "Survey not started",
    territory_change:
      "Select the territory you wish to move the selected locations to",
  },

  titles: {
    availability: "Availability",
    banner_new: "New Banner",
    banner_update: "Update Banner",
    callSummary: "Call Summary",
    credentials: "Credentials",
    clientInformation: "Client Information",
    client_new: "New Client",
    client_update: "Update Client",
    confirmSurveyDelete: "Do you want to delete this survey?",
    copySurvey: "Copy Survey",
    downloadDialog: "Download Options",
    exports: "Exports",
    homePageTitle: "Retail Operations Portal",
    import_listings: "Import Listings",
    import_locations: "Import Locations",
    import_schedule: "Import Schedule",
    import_skuMatrix: "Import SKU matrix",
    importSkusForClient: "Import SKUs",
    imports: "Imports",
    listings: "SKU Listings",
    location_new: "New Location",
    location_update: "Update Location",
    locations: "Locations",
    loginPageTitle: "Retail Operations Portal",
    matrixItems: "Matrix Items",
    options: "Options",
    payPeriod_new: "New Pay Period",
    payPeriod_update: "Update Pay Period",
    personalInformation: "Personal Information",
    projectInformation: "Project Information",
    project_new: "New Project",
    project_update: "Update Project",
    projects: "Projects",
    reps: "Reps",
    retailerInformation: "Retailer Information",
    retailer_new: "New Retailer",
    retailer_update: "Update Retailer",
    territoryInformation: "Territory Information",
    scheduleActions: "Schedule Actions",
    schedules: "Schedules",
    schedule: "My Schedule",
    scheduledLocations: "Scheduled Locations",
    sectionText: "Section Text",
    skus: "SKU's",
    skuMatrix: "SKU Matrix",
    skuTemplate: "SKU Template",
    surveyErrors: "Survey Errors",
    surveyInformation: "Survey Information",
    survey: "Survey",
    surveys: "Surveys",
    geocodeMissing: "Geocode Missing Coordinates",
    survey_new: "New Survey",
    survey_update: "Update Survey",
    surveyDesigner: " Survey Designer",
    surveyPage_new: "New Survey Page",
    surveyQuestion_new: "New Survey Question",
    surveySection_new: "New Survey Section",
    syndicationExports: "Syndication Exports",
    syndicationImports: "Syndication Imports",
    syndicatedProjects: "Syndicated Projects",
    territory_change: "Change Territory",
    territory_new: "New Territory",
    territory_update: "Update Territory",
    territories: "Territories",
    visibility: "Visibility",
  },

  reports: {
    callSummary: {
      title: "Call Summary",
      width: "620px",
      columns: [
        {
          name: "name",
          label: "project",
          width: "200px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px", fontWeight: "bold" },
          clickable: true,
        },
        {
          name: "incomplete",
          label: "Incomplete",
          width: "35px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px" },
          textAlign: "center",
          clickable: true,
        },
        {
          name: "today",
          label: "Today",
          width: "35px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px" },
          textAlign: "center",
          clickable: true,
        },
        {
          name: "tomorrow",
          label: "Tomorrow",
          width: "35px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px" },
          textAlign: "center",
          clickable: true,
        },
      ],
      allowSort: false,
    },
  },

  calendarLists: {
    dow: [
      { id: "sun", name: "Sunday" },
      { id: "mon", name: "Monday" },
      { id: "tue", name: "Tuesday" },
      { id: "wed", name: "Wednesday" },
      { id: "thu", name: "Thursday" },
      { id: "fri", name: "Friday" },
      { id: "sat", name: "Saturday" },
    ],
    weekdays: [
      { id: 0, name: "Sunday", short: "Sun", letter: "S" },
      { id: 1, name: "Monday", short: "Mon", letter: "M" },
      { id: 2, name: "Tuesday", short: "Tue", letter: "T" },
      { id: 3, name: "Wednesday", short: "Wed", letter: "W" },
      { id: 4, name: "Thursday", short: "Thu", letter: "T" },
      { id: 5, name: "Friday", short: "Fri", letter: "F" },
      { id: 6, name: "Saturday", short: "Sat", letter: "S" },
    ],
    months: [
      { id: "0", name: "January", short: "Jan" },
      { id: "1", name: "February", short: "Feb" },
      { id: "2", name: "March", short: "Mar" },
      { id: "3", name: "April", short: "Apr" },
      { id: "4", name: "May", short: "May" },
      { id: "5", name: "June", short: "Jun" },
      { id: "6", name: "July", short: "Jul" },
      { id: "7", name: "August", short: "Aug" },
      { id: "8", name: "September", short: "Sep" },
      { id: "9", name: "October", short: "Oct" },
      { id: "10", name: "November", short: "Nov" },
      { id: "11", name: "December", short: "Dec" },
    ],
  },

  types: {
    callStatus: {
      future: { name: "Future", color: "#ccc" },
      incomplete: { name: "Incomplete", color: "#ff0000" },
      complete: { name: "Complete", color: "#00ff00" },
      expired: { name: "Expired", color: "#ff9800" },
    },
    imageResolution: [
      { id: "high", name: "High Definition" },
      { id: "medium", name: "Medium Definition" },
      { id: "low", name: "Low Definition" },
    ],
    imageNumber: [
      { id: "single", name: "Single Image" },
      { id: "multiple", name: "Multiple Images" },
    ],
    imageType: [
      { id: "standard", name: "Standard" },
      { id: "beforeAfter", name: "Before & After" },
    ],
    previousAnswerTypes: [
      { id: "na", name: "Not Applicable" },
      { id: "initialize", name: "Initialize with Value" },
      { id: "show", name: "Show Value" },
    ],
    pricingRetailLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "national", name: "National" },
      { id: "retailer", name: "Retailer" },
      { id: "banner", name: "Banner" },
    ],
    pricingCountryLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "national", name: "National" },
      { id: "provincial", name: "Provincial" },
    ],
    listingRetailLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "retailer", name: "Retailer" },
      { id: "banner", name: "Banner" },
      { id: "location", name: "Location" },
    ],
    listingCountryLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "national", name: "National" },
      { id: "provincial", name: "Provincial" },
    ],
    questionTypes: [
      { id: "text", name: "Text" },
      { id: "number", name: "Number" },
      { id: "currency", name: "Currency" },
      { id: "date", name: "Date" },
      { id: "time", name: "Time" },
      { id: "select", name: "Select" },
      { id: "checkbox", name: "Checkbox" },
      { id: "radio", name: "Radio" },
      { id: "image", name: "Image" },
      { id: "multiselect", name: "Multi-Select" },
      { id: "signature", name: "Signature" },
      { id: "informational", name: "Informational" },
      { id: "distribution", name: "Distribution" },
      { id: "variability", name: "Variability" },
    ],
    sectionTypes: [
      { id: "question", name: "Question" },
      { id: "sku", name: "SKU" },
      { id: "text", name: "Text" },
    ],
    visibilityFilters: [
      { id: "retailer", name: "Retailer" },
      { id: "banner", name: "Banner" },
      { id: "province", name: "Province" },
    ],
  },

  provinces: [
    { id: "BC", name: "British Columbia" },
    { id: "AB", name: "Alberta" },
    { id: "SK", name: "Saskatchewan" },
    { id: "MB", name: "Manitoba" },
    { id: "ON", name: "Ontario" },
    { id: "QC", name: "Quebec" },
    { id: "NB", name: "New Brunswick" },
    { id: "NS", name: "Nova Scotia" },
    { id: "NL", name: "Newfoundland and Labrador" },
    { id: "PE", name: "Prince Edward Island" },
    { id: "NT", name: "Northwest Territories" },
    { id: "YT", name: "Yukon" },
    { id: "NU", name: "Nunavut" },
  ],

  distribution: {
    questionText: {
      availableForSale:
        "UPON ENTRY is this sku available for sale in this store? (tag & product)",
      actionTaken:
        "ACTON TAKEN BEFORE EXITING THE STORE - If not in distribution what action did you take to get this product into distribution?",
      followUpQuestions: {
        why_tag_not_placed: "Why was tag not placed?",
        why_tag_not_on_shelf: "Why was tag not on shelf?",
        why_not_on_pog: "Why not on POG?",
      },
    },
    availableForSale: [
      { id: "1", name: "YES" },
      { id: "0", name: "NO" },
    ],
    actionTaken: [
      { id: "placedTagandProduct", name: "I placed tag & product" },
      {
        id: "tag-NoBackroomAccess",
        name: "Tag in place, no access to backroom",
      },
      { id: "tag-ProductOrdered", name: "Tag in place, product ordered" },
      { id: "noTag-ProductOnShelf", name: "No tag, product on shelf" },
      {
        id: "noTag-NoProduct-ProductOrdered",
        name: "No tag, no product - Product ordered or in transit",
      },
      { id: "planogramNotCompleted", name: "New planogram not completed" },
    ],
    followUpOptions: {
      why_tag_not_placed: [
        { id: "will_print_later", name: "Will print later" },
        { id: "other", name: "Other" },
      ],
      why_tag_not_on_shelf: [
        { id: "will_print_arrival", name: "Will print when product arrives" },
        { id: "other", name: "Other" },
      ],
      why_not_on_pog: [
        { id: "will_renew_pog", name: "Will renew POG" },
        { id: "not_on_pog", name: "Not on POG" },
        { id: "section_too_small", name: "Section too small" },
        { id: "product_no_sell", name: "Product does not sell well" },
        { id: "other", name: "Other" },
      ],
    },
  },

  outofstock: {
    questionText: {
      productOnShelfOnEntry: "Was there product upon ENTRY?",
      productAdded: "Did you add product?",
    },
    productOnEntry: [
      { id: "true", name: "YES product upon ENTRY" },
      { id: "false", name: "NO product upon ENTRY" },
    ],
    productAdded: [
      { id: "true", name: "YES, product was added" },
      { id: "false", name: "NO, product NOT added" },
    ],
  },
};

export default en_CA;
